import * as React from "react";
import "./index.css";
import { CheckMarkIcon } from "../../icons";
import Button from "../../Button";

const SubmitProgressLabel = ({ label, isComplete, index, setStatus }) => {
  return (
    <button
      className={`submit-progress-label ${isComplete && "active"}`}
      onClick={() => setStatus(index)}
    >
      <div>{label}</div>
      <div className={`submit-progress-label-icon ${isComplete && "active"}`}>
        <span
          style={{
            transform: isComplete ? "translateY(0%)" : "translateY(-100%)",
          }}
        >
          <CheckMarkIcon className={"label-icon"} />
        </span>
        <span
          style={{
            transform: isComplete ? "translateY(0%)" : "translateY(-160%)",
          }}
        >
          {index + 1}
        </span>
      </div>
    </button>
  );
};

const SubmitProgressIndicator = ({ progress, setProgress }) => {

  const status = ["Information", "Cart", "Checkout"];


  return (
    <div className="submit-progress-indicator container">
      <div className="submit-progress-label-base">
        {status.map((e, index) => (
          <>
            <SubmitProgressLabel
              index={index}
              label={e}
              isComplete={index <= progress}
              setStatus={() => {
                if (progress >= index)
                  setProgress(index)
              }}
            />
            {index !== 2 && <div className="submit-progress-divider" />}
          </>
        ))}
      </div>
    </div>
  );
};

export default SubmitProgressIndicator;
